import React from "react";
import Box from "@mui/material/Box";
import AuthHeader from "./AuthHeader";
import AuthFooter from "./AuthFooter";
import AuthFollowUs from "./AuthFollowUs";
import {
  authCardSx,
  authFormInnerSx,
  authFormPanelSx,
} from "./authStyles";
import loginIllustration from "../../Assests/Images/auth/login-illustration.png";
import "./AuthLayout.css";

function AuthLayout(props) {
  var showIllustration =
    props.showIllustration === undefined ? true : props.showIllustration;
  var showFollowUs =
    props.showFollowUs === undefined ? true : props.showFollowUs;

  return (
    <Box
      className="auth-page"
      sx={{
        position: "relative",
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        overflowX: "hidden",
      }}
    >
      <AuthHeader />

      <Box
        component="main"
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 2, sm: 3 },
          py: { xs: 3, sm: 4 },
          width: "100%",
          boxSizing: "border-box",
          position: "relative",
          zIndex: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            flexDirection: { xs: "column", md: "row" },
            gap: "11px",
            width: "100%",
            maxWidth: 1100,
          }}
        >
          <Box sx={authCardSx}>
            {showIllustration ? (
              <Box
                sx={{
                  position: "relative",
                  width: 304,
                  height: 315,
                  flexShrink: 0,
                  overflow: "hidden",
                  display: { xs: "none", md: "block" },
                }}
              >
                <Box
                  component="img"
                  src={loginIllustration}
                  alt=""
                  sx={{
                    position: "absolute",
                    height: "100.15%",
                    width: "165.73%",
                    left: "-36.76%",
                    top: "-0.08%",
                    maxWidth: "none",
                    display: "block",
                  }}
                />
              </Box>
            ) : null}

            <Box sx={authFormPanelSx}>
              <Box sx={authFormInnerSx}>{props.children}</Box>
            </Box>
          </Box>

          {showFollowUs ? <AuthFollowUs /> : null}
        </Box>
      </Box>

      <AuthFooter />
    </Box>
  );
}

export default AuthLayout;
